<div class="col-xs-12 btn-group">
  <button class="btn btn-default btn-sm btn-action" type="button" ng-click="goToIndex()">Cancelar</button>
  <button class="btn btn-success btn-sm btn-action" type="submit"
          ng-disabled="ocorrencia_maquina_form.$invalid"
          ng-if="permissions.maquina.canManage">
    Salvar <i class="fa fa-check"></i>
  </button>
</div>